module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjQxIiBoZWlnaHQ9IjExLjg2OSIgdmlld0JveD0iMCAwIDYuNDEgMTEuODY5Ij4NCiAgPHBhdGggaWQ9IlBhdGhfODc0MSIgZGF0YS1uYW1lPSJQYXRoIDg3NDEiIGQ9Ik0xMjQuMDE3LDUuNjA5LDExOC41MjcuMTM0YS40Ni40NiwwLDEsMC0uNjUuNjUybDUuMTYzLDUuMTQ5LTUuMTYzLDUuMTQ5YS40Ni40NiwwLDAsMCwuNjUuNjUxbDUuNDktNS40NzRhLjQ2LjQ2LDAsMCwwLDAtLjY1MVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTcuNzQyIDApIiBmaWxsPSIjNTM1NTU1Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-icon.svg
// module id = o6mB
// module chunks = 1